<div class="flex gap">
    <!--    <app-button-->
    <!--        icon="pi-external-link"-->
    <!--        severity="secondary"-->
    <!--        label="database.usersPage.export"-->
    <!--    ></app-button>-->
    <p-splitbutton
        label="{{ sortButtonLabel ? sortButtonLabel : ('database.usersPage.sort' | translate) }}"
        icon="{{ sortButtonIcon ? sortButtonIcon : 'pi pi-sort-alt' }}"
        severity="secondary"
        [model]="sortOptions"
        (onClick)="sortButtonClicked()"
    ></p-splitbutton>
    @if (isAllowed['user.create']()) {
        <app-button icon="pi-user-plus" label="database.usersPage.addUser" (clickEvent)="createNew()"></app-button>
    }
</div>
